import { ReactNode } from 'react';
import { Col, Row } from 'react-bootstrap';

export function Caption({ children }: { children: ReactNode }): JSX.Element {
    return (
        <Row>
            <Col xs={12} sm={8} md={6} className="mx-auto text-center">
                {children}
            </Col>
        </Row>
    );
}
